import React from "react";
import { Loader2 } from "lucide-react";
import { AppConfig } from "../../utils/Constants";

const ForgeworksLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background-default dark:bg-background-dark backdrop-blur-sm z-50 transition-opacity duration-300 ease-in-out">
      <div className="flex items-center justify-center h-full">
        <Loader2
          className="w-20 h-20 text-text-primary opacity-30 animate-spin dark:text-text-primaryDark"
          strokeWidth={0.5}
        />
      </div>

      <div className="absolute bottom-10 flex items-center justify-center gap-3 px-6 py-3 rounded-full bg-background-paper/60 dark:bg-background-paperDark/60 backdrop-blur-md border border-divider/30 dark:border-divider-dark/30 shadow-lg">
        <div className="relative flex items-center justify-center">
          <div className="absolute inset-0 bg-secondary/10 dark:bg-secondary/20 rounded-full blur-md"></div>
          <img
            src={AppConfig.LOGO_URL}
            alt="Forgeworks Logo"
            className="w-9 h-9 object-contain relative z-10"
          />
        </div>
        <span className="text-xl font-light tracking-wider text-text-primary dark:text-text-primaryDark relative z-10">
          Forgeworks
        </span>
      </div>
    </div>
  );
};

export default ForgeworksLoader;
